import React from 'react';
import s from './CommentsPrime.scss';
import Comments from '../../components/Comments';

class CommentsPrime extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return <Comments {...this.props} styles={s} isPrime />;
  }
}

export default CommentsPrime;
